export const fmtCurrency = (value, lang) => {
  if (value == null) return "—";
  const locale = lang === "fr" ? "fr-CA" : "en-CA";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "CAD",
    maximumFractionDigits: 0,
  }).format(value);
};

export const fmtCurrencyPrecise = (value, lang) => {
  if (value == null) return "—";
  const locale = lang === "fr" ? "fr-CA" : "en-CA";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "CAD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const fmtNumber = (value, lang) => {
  if (value == null) return "—";
  const locale = lang === "fr" ? "fr-CA" : "en-CA";
  return new Intl.NumberFormat(locale).format(value);
};

export const fmtPct = (value) => {
  if (value == null) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${value}%`;
};

export const fmtCompact = (value, lang) => {
  if (value == null) return "0";
  const locale = lang === "fr" ? "fr-CA" : "en-CA";
  return new Intl.NumberFormat(locale, {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(value);
};
